import React, { useState, useEffect } from "react";
import { Card } from "antd";
import PageHeader from "../../components/headers/PageHeader";
import extraService from "../../services/extrasService";
import Loading from "../../components/layouts/Loading";

export default function Reportes() {
  const [urlDb1, setUrlDb1] = useState(null);
  // const handleCardClick = (title) => {

  const consultaUrl = async () => {
    try {
      const response = await extraService.consultarUrlDashBoard();
      let data = response;

      setUrlDb1(data.embedUrl);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    // Este código se ejecutará solo cuando `open` sea `true`

    consultaUrl();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card title={<PageHeader title="Dashboards" head=""></PageHeader>}>
      {urlDb1 ? (
        <>
          <iframe
            title="dashboard 1"
            src={urlDb1}
            // src="https://metrodemedellin.datahub.net.co/#/Home/Reporte/ZMXJGFOSRV"
            width="100%"
            height="1000px"
            frameborder="0"
          ></iframe>
        </>
      ) : (
        <Loading />
      )}
    </Card>
  );
}
